// Relative import on purpose: the web test runner compiles these files one by one and resolves no alias.
import { ApiRequestError } from './apiClient';

/**
 * The Spanish message the API put in a refusal ("La unidad principal no puede repetirse...", "La solicitud
 * ya fue resuelta..."), or null when the body has none. Nest sends `message` as a string or a list of strings.
 */
export async function mensajeDelServidor(res: Response): Promise<string | null> {
	const body: unknown = await res.json().catch(() => null);
	if (typeof body !== 'object' || body === null) return null;
	const message = (body as { message?: unknown }).message;
	if (typeof message === 'string' && message.trim()) return message;
	if (Array.isArray(message)) {
		const first = message.find((item): item is string => typeof item === 'string' && item.trim().length > 0);
		if (first) return first;
	}
	return null;
}

/**
 * An `ApiRequestError` for a failed response. A client error (4xx) carries the server's own Spanish text so
 * the screen can say WHY (cap, repeated unit, already resolved); a 5xx never leaks its text, and 401/403 use
 * the fallback so the caller classifies them by `status` (session expiry vs permission) as everywhere else.
 */
export async function errorDeRespuesta(res: Response, fallback: string): Promise<ApiRequestError> {
	const esRechazoDeNegocio = res.status < 500 && res.status !== 401 && res.status !== 403;
	const mensaje = esRechazoDeNegocio ? await mensajeDelServidor(res) : null;
	return new ApiRequestError(mensaje ?? fallback, res.status);
}
